<svelte:head>

    <title>Mgmt • Ämtler-Bon Admin</title>

</svelte:head>

<script>

    import SessionManager from "../components/utils/session.svelte";
    import Login from "../components/screens/login.svelte";

</script>

<SessionManager />

<section>

    <Login />

</section>


<style>

    section {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: flex-start;
        height: inherit;
    }

</style>
